import {DailyData} from "src/modules/app/containers";

export class GetDailyData {
  static readonly type = '[FieldMonitoring] Get production and injection daily data';

  constructor(public payload: DailyData) {
  }
}
